import type { ComponentProps } from "react";
import { PrimaryNav, navItems } from "./primary-nav.js";
import { Ellipsis, Flag, House, Shield, Swords } from "./approved-icons.js";

const items = navItems.map((item) => {
  if (item.key === "feed")
    return {
      ...item,
      page: "fgl" as const,
      label: "Season",
      matches: ["fgl" as const],
    };
  if (item.key === "clubhouse")
    return { ...item, matches: ["clubhouse" as const, "feed" as const] };
  if (item.key === "more")
    return { ...item, matches: item.matches.filter((page) => page !== "fgl") };
  return item;
});
const icons = {
  clubhouse: House,
  "tee-off": Flag,
  rivalry: Swords,
  feed: Shield,
  more: Ellipsis,
};

/** Approved A3 labels and drawings on the existing production navigation. */
export function ApprovedNavigation(
  props: ComponentProps<typeof PrimaryNav>,
): React.JSX.Element {
  return (
    <div className="fr-approved-navigation">
      <PrimaryNav
        {...props}
        items={items}
        renderIcon={(key) => {
          const Icon = icons[key];
          return <Icon size={22} />;
        }}
      />
    </div>
  );
}
